exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cardTooltips__tooltip___1IGWV{margin-left:10px}.cardTooltips__icon___2xo3O{margin-bottom:-4px}.cardTooltips__tooltip___1IGWV.cardTooltips__active___1PpCA:before{display:block;position:fixed;left:0;top:0;background:#000;background:rgba(0,0,0,.6);width:100%;height:100%;z-index:10}.cardTooltips__tooltipBody___24ECK{top:50%;-ms-transform:translate(-50%,-50%);position:fixed;width:80%;top:20%;left:50%;transform:translate(-50%,-50%);bottom:inherit}.cardTooltips__tooltipBody___24ECK:after{display:none}.cardTooltips__tooltipBody___24ECK.cardTooltips__active___1PpCA{bottom:inherit}.cardTooltips__tooltipBody___24ECK.cardTooltips__active___1PpCA:before{display:block;position:fixed;left:0;top:0;background:#000;background:rgba(0,0,0,.6);width:100%;height:100%;z-index:10}", ""]);

// exports
exports.locals = {
	"tooltip": "cardTooltips__tooltip___1IGWV",
	"icon": "cardTooltips__icon___2xo3O",
	"active": "cardTooltips__active___1PpCA",
	"tooltipBody": "cardTooltips__tooltipBody___24ECK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/ExplorerTabContent/overrides/cardTooltips.pcss
// module id = 884
// module chunks = 0